/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-default";

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = "en";
export const defaultDirection = "ltr";

export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

export const SUPPORT_PHONE_RAW = "+18014320512";
